import { conditions, footerPadding } from "helpers";
import { ConditionName, zIndex } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";
import ProgressBar from "./progressbar/progressbar";
import Controllbar from "./controllbar/controllbar";

const AutoPlayListIcon = dynamic(() => import("../../player-components/autoPlay/autoPlayListIcon"));
const InstagramEmoji = dynamic(() => import("../../player-components/InstagramEmoji/InstagramEmoji"));

const Footer = () => {

    useAppSelector(({ controller: { lock, isFullScreen } }) => ({ lock, isFullScreen }), shallowEqual);
    const {settings} = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);
    const { subtitleText } = useAppSelector(({ videoData: { subtitleText, selectedSubtitle } }) => ({ subtitleText, selectedSubtitle }), shallowEqual);

    const subtitlePosition = () => {
        let styles = "";
        if(conditions(ConditionName.isLock)) styles = "pl-bottom-3"
        else if (conditions(ConditionName.isActiveElements)) {
            styles = "pl-subtitle-text pl-bottom-[100px]"
            if (conditions(ConditionName.isComplexPortrait)) styles = `pl-subtitle-text !pl-bottom-[55px]`
        } else if (!conditions(ConditionName.isActiveElements)) styles = "pl-bottom-3"

        return styles;
    }

    return (
        <div id="footer" className="pl-relative" style={{zIndex: zIndex.footer}}>
            {conditions(ConditionName.showAutoPlayListTouchIcon) && <AutoPlayListIcon />}
            {conditions(ConditionName.isSelectedSubtitle) && <pre id={"subtitle-id"} style={{ direction: "ltr", fontFamily: "IranYekanFaMobile", opacity: (settings.brightness / 100) }} className={`pl-absolute pl-text-white pl-w-full pl-mx-auto pl-text-center pl-text-[36px] ${conditions(ConditionName.isComplexPortrait) && "!pl-text-[13px]"} ${conditions(ConditionName.isTouchScreenLandscape) && "!pl-text-[24px]"} pl-font-normal ${subtitlePosition()}`}>{subtitleText}</pre>}
            {!conditions(ConditionName.isLock) && (
                <>
                    {!conditions(ConditionName.isComplexPortrait) && <div className={`pl-w-full pl-h-full pl-absolute animate__animated animate__faster ${conditions(ConditionName.isActiveElements) ? "animate__fadeIn" : "animate__fadeOut"}`} style={{ background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 2.54%, rgba(0, 0, 0, 0.8) 87.05%, rgba(0, 0, 0, 0.8) 87.05%)" }} />}
                    <div
                        className={`pl-w-full pl-mx-auto animate__animated animate__faster ${conditions(ConditionName.isActiveElements) ? "animate__fadeIn pl-pointer-events-auto" : "animate__fadeOut pl-pointer-events-none"}`}
                        style={{ paddingLeft: footerPadding(), paddingRight: footerPadding() }}
                    >
                        {conditions(ConditionName.showProgressbar) && <ProgressBar />}
                        {!conditions(ConditionName.isComplexPortrait) && <Controllbar />}
                    </div>
                    {conditions(ConditionName.showInstagramEmoji) && <InstagramEmoji />}
                </>
            )}
        </div>

    )
}

export default Footer;